import React, { Component } from 'react';
import Product from './Product';

class Products extends Component {

  render() {

    let elementIndex = -1
    let shirts = this.props.shirts && this.props.shirts.map((product) => {
      elementIndex += 1;
      return (
        <Product
          Index={elementIndex}
          addVariantToCart={this.props.addVariantToCart}
          client={this.props.client}
          key={product.id.toString()}
          category="448065863977"
          product={product}
          products={this.props.shirts}
          isCustomCollection={false}
        />
      );
    });

    elementIndex = -1
    let hats = this.props.hats && this.props.hats.map((product) => {
      elementIndex += 1;
      return (
        <Product
          Index={elementIndex}
          addVariantToCart={this.props.addVariantToCart}
          client={this.props.client}
          category="448065700137"
          key={product.id.toString()}
          product={product}
          products={this.props.hats}
          isCustomCollection={false}
        />
      );
    });

    elementIndex = -1
    let accessarries = this.props.accessarries && this.props.accessarries.map((product) => {
      elementIndex += 1;
      return (
        <Product
          Index={elementIndex}
          addVariantToCart={this.props.addVariantToCart}
          client={this.props.client}
          category="448066027817"
          key={product.id.toString()}
          product={product}
          products={this.props.accessarries}
          isCustomCollection={false}
        />
      );
    });

    elementIndex = -1
    let customCollectionData = this.props.customCollectionData && this.props.customCollectionData.map((product) => {
      elementIndex += 1;
      return (
        <Product
          Index={elementIndex}
          addVariantToCart={this.props.addVariantToCart}
          client={this.props.client}
          category="collection"
          key={product.id.toString()}
          product={product}
          products={this.props.customCollectionData}
          isCustomCollection={true}
        />
      );
    });


    return (
      <div style={{ display: "inline-block" }}>
        {this.props.customCollection ? "" :
        <div className="Product_section">
          <div className="product_breadcrumb">
              <h5 align="center">
                {this.props.collection1 && <a href="#HATS">{this.props.collection1.title}</a> } {this.props.collection1 && '-' }
                {this.props.collection2 && <a href="#SHIRTS">{this.props.collection2.title}</a> } {this.props.collection2 && '-' }
                {this.props.collection3 && <a href="#ACCESSORIES">{this.props.collection3.title}</a> }
              </h5>
          </div>
        </div>
        }
        <div className="container-fluid">
          <div className="Product_page">

          {this.props.collection1 &&
            <React.Fragment>
              <div className="row" id="HATS" style={{ display: "block", justifyContent: "center", display: "block" }}>
                <p className="sub-title" dangerouslySetInnerHTML={{__html: this.props.collection1.descriptionHtml}}></p>
                <h4 className="header-product">{this.props.collection1.title}</h4>
              </div>
              <div className="row pt-4">
                {hats}
              </div>
            </React.Fragment>
          }

          {this.props.collection2 &&
            <React.Fragment>
            <div className="row" id="SHIRTS" style={{ borderBottom: "1px solid white" }}>
              <h4 className="header-product">{this.props.collection2.title}</h4>
              {/* <p className="sub-title" dangerouslySetInnerHTML={{__html: this.props.collection2.descriptionHtml}}></p> */}
            </div>
            <div className="row pt-4">
              {shirts}
            </div>
            </React.Fragment>
          }

          {this.props.collection3 &&
            <React.Fragment>
            <div className="row" id="ACCESSORIES" style={{ borderBottom: "1px solid white" }}>
              <h4 className="header-product">{this.props.collection3.title}</h4>
              {/* <p className="sub-title" dangerouslySetInnerHTML={{__html: this.props.collection3.descriptionHtml}}></p> */}
            </div>
            <div className="row pt-4">
              {accessarries}
            </div>
            </React.Fragment>
          }

          {this.props.customCollection &&
            <React.Fragment>
            <div className="row" id="ACCESSORIES" style={{ borderBottom: "1px solid white", display: "block" }}>
              <h4 className="header-product">{this.props.customCollection.title}</h4>
              <p className="sub-title" dangerouslySetInnerHTML={{__html: this.props.customCollection.descriptionHtml}}></p>
            </div>
            <div className="row pt-4">
              {customCollectionData}
            </div>
            </React.Fragment>
          }

          </div>
        </div>
      </div>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js